import React, { useEffect, useState } from 'react';
import { Field as Fieldmik, FieldArray, ErrorMessage } from 'formik';
import { Form as FormUi, Input, Button, Dropdown, Grid, Header, Table, Icon } from 'semantic-ui-react';

import { DateData } from '../formikInput/date';
import { MyInput, MyNormalInput } from '../formikInput/input';

import ProductSKUDropdown from '../dropdowns/productSKUDropdown';



const AddProduct = ({ handleChange, billmode, masterState, vendorStateId, gstNotApplicableReason, isGstApplicable, vendorPsLineGSTMappingData }) => {
    // console.log("vendorPsLineGSTMappingData", {activePOSum})
    const [productData, setProductData] = useState([])
    const [isUpdated, setisUpdated] = useState(false);

    const getProductData = childData => {
        setProductData(childData);
    }

    const valueChangeDiscount = (object) => {
        setisUpdated(object.discountType);
        let tempAmount = '';
        if (object.discount > 0 && object.discountType == 1) {
            let finalRate = +object.rate * +object.quantity
            tempAmount = +finalRate - +object.discount
        } else {
            let finalRate = +object.rate * +object.quantity
            tempAmount = +finalRate - (+finalRate * +object.discount / 100)
        }
        object.iGst = isGstApplicable ? +object.iGstPercent / 100 * +tempAmount : 0;
        object.cGst = isGstApplicable ? +object.cGstPercent / 100 * +tempAmount : 0;
        object.sGst = isGstApplicable ? +object.sGstPercent / 100 * +tempAmount : 0;

        object.taxableAmount = +tempAmount

        return object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst
    };

    const getVendorPSLineGSTPercent = (psLineId) => {
        if(vendorPsLineGSTMappingData && vendorPsLineGSTMappingData.length > 0){
            let temp = vendorPsLineGSTMappingData.filter(e => {
                return e.psLineItemId == psLineId
            })
            return temp[0]?.gstPercent ? parseInt(temp[0]?.gstPercent) : null
        }
        return null
    }

    return (
        <div className="ui form tiny">
            <FieldArray
                key={isUpdated}
                name="productDetails">
                {({ push, remove, replace, form }) => {

                    const { inititalValues, values, setFieldValue } = form
                    const { productDetails } = values

                    let activePOSum = 0

                    activePOSum = values?.activeSOSelected?.reduce((acc, curr) => {
                        return values.isGstApplicable ? acc + +curr.poAmount : acc + +curr.taxableAmount
                    }, 0)

                    let productSelectedArray = []

                    productDetails.map((product, index) => {
                        let temp = {}
                        temp.productName = product.productName

                        productSelectedArray[index] = temp
                    })
                    let finalAMT = 0
                    values.productDetails.map(({ amount }) => finalAMT += amount)
                    values.finalAmount = finalAMT
                    const handleUpdateProduct = (e, data, index, object) => {

                        const { setFieldValue } = form

                        let addedProductObject = productData.filter(e => {
                            return e.psId === data.value
                        })


                        if (addedProductObject.length) {
                            setFieldValue(data.name, data.value).then(() => {
                                let vendorPSLineGSTPercent = getVendorPSLineGSTPercent(data.value) || null
                                replace(index, {
                                    productName: data.value,
                                    productCode: addedProductObject && addedProductObject[0] && addedProductObject[0].psCode || "",
                                    hsnCode: addedProductObject && addedProductObject[0] && addedProductObject[0].HSNCode || "",
                                    sacCode: addedProductObject && addedProductObject[0] && addedProductObject[0].SACCode || "",
                                    quantity: object.quantity,
                                    discountType: object.discountType,
                                    discount: addedProductObject && addedProductObject[0] && addedProductObject[0].discount || 0,
                                    tdsId: addedProductObject && addedProductObject[0] && addedProductObject[0].tdsTaxSectionId || "",
                                    tdsTaxCode: addedProductObject && addedProductObject[0] && addedProductObject[0].tdsTaxCode || "",
                                    rate: addedProductObject && addedProductObject[0] && addedProductObject[0].sellingPrice || 0,
                                    iGstPercent: vendorStateId === masterState ? "" : vendorPSLineGSTPercent !== null ? vendorPSLineGSTPercent : addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage,
                                    cGstPercent: vendorStateId === masterState ? vendorPSLineGSTPercent !== null ? vendorPSLineGSTPercent/2 : addedProductObject && addedProductObject[0] && parseInt(addedProductObject[0].gstPercentage) / 2 : "",
                                    sGstPercent: vendorStateId === masterState ? vendorPSLineGSTPercent !== null ? vendorPSLineGSTPercent/2 : addedProductObject && addedProductObject[0] && parseInt(addedProductObject[0].gstPercentage) / 2 : "",
                                    remarks:object.remarks

                                })
                            })
                        }
                    }

                    return (
                        <>
                            <Table unstackable size="large" key={isUpdated} compact="very" className="w3-small">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell className="w3-white" colSpan="10">  <label className="labelName w3-text-blue" style={{ display: "flex" }}>Product/Service Details  </label>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="8">
                                            {
                                                gstNotApplicableReason ?
                                                    <h2 style={{ fontSize: '12px', color: '#1678c2' }} className='mt-2'>Reason:  {gstNotApplicableReason}</h2>
                                                    : null
                                            }
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row >
                                        <Table.HeaderCell className="labelName p-bold-600">Product Details</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">HSN/SAC Code</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">IGST%</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">IGST(₹)</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">CGST</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">CGST(₹)</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">SGST</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">SGST(₹)</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Remark</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {productDetails.map((object, index) => {

                                        const discountOptions = [
                                            { key: '1', text: '₹', value: '1' },
                                            { key: '2', text: '%', value: '2' },
                                        ];


                                        let tempAmount = '';
                                        if (object.discount > 0 && object.discountType == 1) {
                                            let finalRate = +object.rate * +object.quantity
                                            tempAmount = +finalRate - +object.discount
                                        } else {
                                            let finalRate = +object.rate * +object.quantity
                                            tempAmount = +finalRate - (+finalRate * +object.discount / 100)
                                        }
                                        object.iGst = object.iGstPercent ? isGstApplicable ? +object.iGstPercent / 100 * +tempAmount : 0 : 0;
                                        object.cGst = object.cGstPercent ? isGstApplicable ? +object.cGstPercent / 100 * +tempAmount : 0 : 0;
                                        object.sGst = object.sGstPercent ? isGstApplicable ? +object.sGstPercent / 100 * +tempAmount : 0 : 0;

                                        object.taxableAmount = +tempAmount

                                        object.amount = 
                                            values.isGstApplicable ?
                                                +tempAmount + +object.iGst + +object.cGst + +object.sGst :
                                                +tempAmount
                                        //console.log("values.object", object)

                                        return (
                                            <Table.Row verticalAlign="middle" key={index} >
                                                <React.Fragment>
                                                    <Table.Cell>
                                                        <div style={{ display: "flex" }}>
                                                            <Fieldmik
                                                                component={ProductSKUDropdown}
                                                                handleUpdateProduct={handleUpdateProduct}
                                                                productIndex={index}
                                                                productObject={object}
                                                                getProductData={getProductData}
                                                                placeholder="Product Name"
                                                                name={`productDetails[${index}].productName`}
                                                                style={{ width: '180px' }}
                                                                value={object.productName ? object.productName : ''}
                                                                productSelectedArray={productSelectedArray}
                                                                selectedProductEdit={object.productName}
                                                                masterBranchStateId={masterState}
                                                                vendorBranchStateId={vendorStateId}
                                                            />
                                                        </div>
                                                        <ErrorMessage name={`productDetails[${index}].productName`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>
                                                    {/* <Table.Cell style={{ minWidth: '124px'}}>
                                                            <DateData
                                                                name={`productDetails[${index}].startDate`}
                                                                autoComplete="off"
                                                                popperClassName="dateTime"
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Start Date"
                                                                selected={productDetails[index].startDate}
                                                                selectsStart
                                                                startDate={productDetails[index].startDate}
                                                                maxDate={productDetails[index]['endDate'] ? productDetails[index]['endDate'] : ''}
                                                                endDate={productDetails[index]['endDate']}
                                                                timeIntervals={5}
                                                                customInput={<FormUi.Input error={productDetails[index].startDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                            />                                                                          
                                                        </Table.Cell>
                                                        <Table.Cell style={{ minWidth: '124px'}}>
                                                            <DateData
                                                                name={`productDetails[${index}].endDate`}
                                                                autoComplete="off"
                                                                popperClassName="dateTime"
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="End Date"
                                                                selected={productDetails[index].endDate}
                                                                selectsStart
                                                                startDate={productDetails[index].endDate}
                                                                endDate={productDetails[index]['startDate']}
                                                                minDate={productDetails[index]['startDate'] ? productDetails[index]['startDate'] : ''}
                                                                timeIntervals={5}
                                                                customInput={<FormUi.Input error={productDetails[index].endDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                            />                                                                          
                                                        </Table.Cell> */}
                                                    <Table.Cell width={1}>{object.hsnCode || object.sacCode ? `${object.hsnCode, object.sacCode}` : ''}</Table.Cell>
                                                    <Table.Cell style={{ minWidth: '50px' }}>
                                                        <Fieldmik
                                                            component={MyNormalInput}
                                                            type="number"
                                                            value={object.quantity === 0 ? '' : object.quantity}
                                                            min="1"
                                                            autoComplete="off"
                                                            name={`productDetails[${index}].quantity`}
                                                            size="small"
                                                        />
                                                        <ErrorMessage name={`productDetails[${index}].quantity`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>
                                                    <Table.Cell style={{ minWidth: '70px' }}>
                                                        <Fieldmik
                                                            component={MyNormalInput}
                                                            type="number"
                                                            min="0"
                                                            value={object.rate === 0 ? 0 : object.rate}
                                                            autoComplete="off"
                                                            name={`productDetails[${index}].rate`}
                                                            size="small"
                                                        />
                                                        <ErrorMessage name={`productDetails[${index}].rate`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>
                                                    <Table.Cell style={{ minWidth: '100px' }}>
                                                        <Fieldmik style={{ width: '50%' }} type="number" component={MyNormalInput} value={object.discount === 0 ? 0 : object.discount} name={`productDetails[${index}].discount`} size="small"
                                                            label={<Dropdown placeholder={object.discountType === 2 ? '%' : "₹"} options={discountOptions} defaultValue={object.discountType}
                                                                onChange={(value, data) => {
                                                                    object.discountType = data.value
                                                                    valueChangeDiscount(object)
                                                                }} />} labelPosition="right" className="tableinput" />
                                                    </Table.Cell>
                                                    <Table.Cell>{object.iGstPercent && values.isGstApplicable ? `${object.iGstPercent}%` : '0%'}</Table.Cell>
                                                    <Table.Cell>{object.iGst && values.isGstApplicable ? object.iGst.toFixed(2) : '0'}</Table.Cell>
                                                    { console.log("values.object", object)}
                                                    <Table.Cell>{object.cGstPercent && values.isGstApplicable ? `${object.cGstPercent}%` : '0%'}</Table.Cell>
                                                    <Table.Cell>{object.cGst && values.isGstApplicable ? object.cGst.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell>{object.sGstPercent && values.isGstApplicable ? `${object.sGstPercent}%` : '0%'}</Table.Cell>
                                                    <Table.Cell>{object.sGst && values.isGstApplicable ? object.sGst.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell>{object.amount ? object.amount.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell>
                                                    <Fieldmik
                                                            component={MyNormalInput}
                                                            type="text"
                                                            value={object.remarks}
                                                            autoComplete="off"
                                                            name={`productDetails[${index}].remarks`}
                                                            size="small"
                                                        />
                                                        <ErrorMessage name={`productDetails[${index}].rate`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>
                                                    <Table.Cell hidden={index > 0 ? false : true} textAlign="right">
                                                        <Button onClick={() => remove(index)} type="button" basic size="mini" icon>
                                                            <Icon className="overhere" color="red" name="trash" />
                                                        </Button>
                                                    </Table.Cell>
                                                </React.Fragment>

                                            </Table.Row>
                                        )
                                    }
                                    )}
                                </Table.Body>
                            </Table>
                            <Grid columns={3}>
                                <Grid.Row className="p-2">
                                    <Grid.Column width={10}>
                                        <Button className="ml-2" type="button" onClick={() => push({ productName: '', startDate: '', endDate: '', hsnCode: '', sacCode: '', quantity: 1, rate: '', discount: '', discountType: '1', iGstPercent: '', iGst: '', cGstPercent: '', cGst: '', sGstPercent: '', sGst: '', amount: '',remarks:'' })} size="mini" basic color="blue">
                                            + Add Product
                                        </Button>
                                    </Grid.Column>
                                    <Grid.Column>
                                        {billmode ?
                                            <>
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New PO Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {isNaN(values.manualPoAddedTotal) ? "0.00" : values.manualPoAddedTotal}</Header>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active PO Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {isNaN(activePOSum) ? "0.00" : activePOSum}</Header>
                                                </Grid.Row>
                                            </>
                                            :
                                            ""
                                        }
                                        <Grid.Row>
                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {billmode ? isNaN(values.manualPoAddedTotal) ? activePOSum : activePOSum + +values.manualPoAddedTotal : values.finalAmount ? (Number(values.finalAmount).toFixed(2)) : ''}</Header>
                                        </Grid.Row>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </>
                    )
                }
                }
            </FieldArray>
        </div>
    )
}

export default AddProduct











